/**
 * Recurpay Subscription Confirmation Interception
 * Handles the "dummy-proof" popup for standard product pages.
 */

(function () {
    function initSubscriptionConfirmation() {
        const atcButtons = document.querySelectorAll('[ref="addToCartButton"], .product-form__submit, #AddToCartButton');
        const modal = document.getElementById('RecurpayConfirmation');

        if (!atcButtons.length || !modal) return;

        atcButtons.forEach(button => {
            // We use a capture phase listener to intercept before the theme's own handlers if possible
            // Or just a regular listener and we stop propagation
            button.addEventListener('click', function (e) {
                const form = button.closest('form[action*="/cart/add"]');
                if (!form) return;

                const sellingPlanInput = form.querySelector('input[name="selling_plan"]');
                // Recurpay usually sets selling_plan to a non-empty value when subscription is selected
                if (sellingPlanInput && sellingPlanInput.value && sellingPlanInput.value !== "") {
                    // It's a subscription!

                    // If already confirmed, let it through
                    if (button.dataset.subscriptionConfirmed === 'true') {
                        return;
                    }

                    e.preventDefault();
                    e.stopPropagation();
                    e.stopImmediatePropagation();

                    showConfirmationPopup(form, button);
                }
            }, { capture: true });
        });

        /**
         * @param {HTMLFormElement} form 
         * @param {HTMLElement} originalButton 
         */
        function showConfirmationPopup(form, originalButton) {
            const nextShipDateEl = document.getElementById('RecurpayNextShipDate');
            const billingFreqEl = document.getElementById('RecurpayBillingFrequency');
            const confirmBtn = document.getElementById('RecurpayConfirmBtn');
            const changeBtn = document.getElementById('RecurpayChangeToOneTimeBtn');
            /** @type {HTMLInputElement | null} */
            const sellingPlanInput = form.querySelector('input[name="selling_plan"]');
            /** @type {any} */
            const modalElement = modal;

            if (!nextShipDateEl || !billingFreqEl || !confirmBtn || !changeBtn || !modalElement) {
                console.warn('Subscription confirmation modal elements not found');
                return;
            }

            // 1. Identify Frequency
            // We try to find the selected interval from Recurpay widget labels
            let frequencyText = "every month"; // Default
            let daysToAdd = 30;

            // Look for Recurpay labels or selected options
            const allText = form.innerText.toLowerCase();

            if (allText.includes('2 weeks') || allText.includes('bi-weekly')) {
                frequencyText = "every 2 weeks";
                daysToAdd = 14;
            } else if (allText.includes('month')) {
                frequencyText = "every month";
                daysToAdd = 30;
            }

            // 2. Calculate Date
            const nextDate = new Date();
            nextDate.setDate(nextDate.getDate() + daysToAdd);
            /** @type {Intl.DateTimeFormatOptions} */
            const options = { month: 'long', day: 'numeric', year: 'numeric' };
            const formattedDate = nextDate.toLocaleDateString('en-US', options);

            // 3. Update UI
            nextShipDateEl.textContent = formattedDate;
            billingFreqEl.textContent = frequencyText;

            // 4. Handle Actions
            confirmBtn.onclick = () => {
                originalButton.setAttribute('data-subscription-confirmed', 'true');
                if (typeof modalElement.closeDialog === 'function') {
                    modalElement.closeDialog();
                }
                originalButton.click(); // Trigger again, will pass the check now

                // Reset for next time (in case they stay on page)
                setTimeout(() => {
                    originalButton.removeAttribute('data-subscription-confirmed');
                }, 1000);
            };

            changeBtn.onclick = () => {
                // Find one-time purchase option in Recurpay widget and click it
                const oneTimeOption = form.querySelector('.recurpay__onetime-purchase, .recurpay-onetime label, input[value="onetime"]');
                if (oneTimeOption instanceof HTMLElement) {
                    oneTimeOption.click();
                } else if (sellingPlanInput) {
                    // Fallback: just clear selling plan if possible (risky if widget re-sets it)
                    sellingPlanInput.value = "";
                    // Trigger a change event so Recurpay widget might react
                    sellingPlanInput.dispatchEvent(new Event('change', { bubbles: true }));
                }
                if (typeof modalElement.closeDialog === 'function') {
                    modalElement.closeDialog();
                }
            };

            // 5. Open Modal
            if (typeof modalElement.showDialog === 'function') {
                modalElement.showDialog();
            }
        }
    }

    // Initialize on load and after any dynamic content changes (like variant switches)
    document.addEventListener('DOMContentLoaded', initSubscriptionConfirmation);

    // Re-init when variant changes (Shopify themes often re-render the button)
    document.addEventListener('variant:change', () => {
        setTimeout(initSubscriptionConfirmation, 100);
    });

    // Also support the theme's specific variant update event if it exists
    document.addEventListener('variant:update', () => {
        setTimeout(initSubscriptionConfirmation, 100);
    });
})();
